import { ProvisionEvent } from "features/provisioning/provisions/models/provision-models"

export type ProvisionEventQuery = {
  customerId?: string
  siteId?: string
  assetId?: string
  assetSectionId?: string
}

export function filterProvisionEvents(provisionEvents: ProvisionEvent[], query: ProvisionEventQuery): ProvisionEvent[] {
    if (!provisionEvents) {
        // Handle the case where provisionEvents is null or undefined
        return [];
    }

    try {
        return provisionEvents.filter(p => {
            const { customerId, siteId, assetId, assetSectionId } = query;

            // You can add similar checks for assetSectionId if necessary

            if (customerId && p.customer?.id !== customerId) return false;
            if (siteId && p.site?.id !== siteId) return false;
            if (assetId && p.asset.id !== assetId) return false;

            // Include more checks here if needed for other fields like assetSectionId

            return true;
        });
    } catch (e) {
        console.error('Error filtering provision events:', e);
        // Decide how you want to handle errors. For now, returning passed provisionEvents.
        return provisionEvents;
    }
}
